import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faHtml5,
	faCss3Alt,
	faJs,
	faNode,
	faGitAlt,
	faReact,
	faSass,
	faWordpress,
	faPython,
	faCodepen,
	faGithubAlt,
	faTwitter
} from '@fortawesome/free-brands-svg-icons';
import {
	faChevronLeft,
	faTimes,
	faHeart
} from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import App from './App';

library.add(
	faHtml5,
	faCss3Alt,
	faJs,
	faNode,
	faGitAlt,
	faReact,
	faSass,
	faWordpress,
	faPython,
	faChevronLeft,
	faCodepen,
	faGithubAlt,
	faTwitter,
	faTimes,
	faHeart
);

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js